import { render, staticRenderFns } from "./ModerateExperienceInfo.vue?vue&type=template&id=6568b341&scoped=true&"
import script from "./ModerateExperienceInfo.vue?vue&type=script&lang=js&"
export * from "./ModerateExperienceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModerateExperienceInfo.vue?vue&type=style&index=0&id=6568b341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568b341",
  null
  
)

export default component.exports